import {
  FormattingToolbar,
  FormattingToolbarController,
  getFormattingToolbarItems,
} from '@blocknote/react';

import { CouplespaceCreateLinkButton } from './CouplespaceCreateLinkButton.web';

export function CouplespaceFormattingToolbarController() {
  return (
    <FormattingToolbarController
      formattingToolbar={() => (
        <FormattingToolbar>
          {getFormattingToolbarItems().map((item) =>
            item.key === 'createLinkButton' ? (
              <CouplespaceCreateLinkButton key="createLinkButton" />
            ) : (
              item
            ),
          )}
        </FormattingToolbar>
      )}
    />
  );
}
